import React from "react";
//import logo from './logo.svg';
import "./App.css";
import "./novel-object-video-counter.jsx";
import NovelObjectVideoCounter from "./novel-object-video-counter.jsx";

function App() {
  return (
    <div className="App">
      <h1>Novel Object Video Counter</h1>
      <p>
        Enter the duration of the video in the box below and press start.
      </p>
      <p>
        Use the arrow keys or on-screen buttons to move the mouse.
      </p>
      <NovelObjectVideoCounter />
    </div>
  );
}

export default App;
